<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Restricted Area</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">This is restricted area menu</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Restricted Area</h4>

              <!-- Switch -->
              <div class="form-check form-switch">
                <button
                  class="btn btn-success"
                  v-b-modal.modal-1
                  @click="isAdd = true"
                >
                  <i class="fe fe-plus-circle"></i>
                  <span class="ms-2">Create new</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-end mb-3">
                <label class="align-self-center mb-0 mr-3">Search</label>
                <b-form-input
                  v-model="searchTerm"
                  class="w-auto"
                  placeholder="Type Here..."
                ></b-form-input>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="list"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  externalQuery: searchTerm,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength,
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'details'">
                    {{ props.row.details.length }} Area
                  </span>
                  <span v-else-if="props.column.field == 'created_at'">
                    {{ formatDate(props.row.created_at) }}
                  </span>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-sm btn-warning me-2"
                      @click="updateData(props.row)"
                    >
                      Edit
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      @click.prevent="remove(props.row.id)"
                    >
                      Delete
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="
                          (value) => props.pageChanged({ currentPage: value })
                        "
                      >
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
      <b-modal id="modal-1" size="xl" hide-footer title="Form Restricted Area">
        <form @submit.prevent="saveAdd()" v-if="isAdd === true">
          <div class="form-group">
            <div class="row g-3">
              <div class="form-group col-6">
                <label>Target Type</label>
                <v-select
                  v-model="bodyAdd.entity_type"
                  :reduce="(option) => option.id"
                  :options="targetTypeOpt"
                  v-validate="'required'"
                  name="Entity Type"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Entity Type')"
                  >{{ errors.first("Entity Type") }}</span
                >
              </div>
              <div
                v-if="bodyAdd.entity_type === 'PERSON'"
                class="form-group col-6"
              >
                <label>Entity Value</label>
                <v-select
                  v-model="bodyAdd.entity_value"
                  :options="users"
                  label="fullname"
                  :reduce="(e) => e.keycloak_id"
                  name="Entity Value"
                  v-validate="'required'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Entity Value')"
                  >{{ errors.first("Entity Value") }}</span
                >
              </div>
            </div>
            <div
              class="row g-3"
              v-for="(item, index) in bodyAdd.formAdd"
              :key="index"
            >
              <div class="form-group col">
                <label>Location</label>
                <v-select
                  v-model="item.location_id"
                  :options="location"
                  label="location_name"
                  :reduce="(e) => e.id"
                  name="Location"
                  v-validate="'required'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Location')"
                  >{{ errors.first("Location") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Warning Level</label>
                <v-select
                  v-model="item.warning_level"
                  :reduce="(option) => option.id"
                  :options="warningLevelOpt"
                  v-validate="'required'"
                  name="Warning Level"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Warning Level')"
                  >{{ errors.first("Warning Level") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Start At</label>
                <input
                  type="date"
                  v-model="item.start_at"
                  class="form-control"
                  placeholder="Start At"
                  v-validate="'required'"
                  name="Start At"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Start At')"
                  >{{ errors.first("Start At") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Expired At</label>
                <b-form-input
                  :formatter="format"
                  type="datetime-local"
                  v-model="item.expired_at"
                  class="form-control"
                  placeholder="Expired At"
                  v-validate="'required'"
                  name="Expired At"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Expired At')"
                  >{{ errors.first("Expired At") }}</span
                >
              </div>
              <div class="form-group col-1" v-if="index >= 0">
                <button
                  type="button"
                  style="margin-left: auto"
                  class="btn btn-secondary mt-4"
                  @click="removeArea(index)"
                >
                  <span class="fe fe-trash"></span>
                </button>
              </div>
            </div>
            <div class="row">
              <button
                type="button"
                class="btn btn-primary col-1"
                @click="addArea"
              >
                <span class="fe fe-plus"></span> Add
              </button>
            </div>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false"
            >
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
          </div>
        </form>

        <form @submit.prevent="saveUpdate()" v-else>
          <div class="form-group">
            <div class="row g-3">
              <div class="form-group col-6">
                <label>Target Type</label>
                <v-select
                  v-model="bodyUpdate.entity_type"
                  :reduce="(option) => option.id"
                  :options="targetTypeOpt"
                  v-validate="'required'"
                  name="Entity Type"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Entity Type')"
                  >{{ errors.first("Entity Type") }}</span
                >
              </div>
              <div
                v-if="bodyUpdate.entity_type === 'PERSON'"
                class="form-group col-6"
              >
                <label>Entity Value</label>
                <v-select
                  v-model="bodyUpdate.entity_value"
                  :options="users"
                  label="fullname"
                  :reduce="(e) => e.keycloak_id"
                  name="Entity Value"
                  v-validate="'required'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Entity Value')"
                  >{{ errors.first("Entity Value") }}</span
                >
              </div>
            </div>
            <div
              class="row g-3"
              v-for="(item, index) in bodyUpdate.formUpdate"
              :key="index"
            >
              <div class="form-group col">
                <label>Location</label>
                <v-select
                  v-model="item.location_id"
                  :options="location"
                  label="location_name"
                  :reduce="(e) => e.id"
                  name="Location"
                  v-validate="'required'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Location')"
                  >{{ errors.first("Location") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Warning Level</label>
                <v-select
                  v-model="item.warning_level"
                  :reduce="(option) => option.id"
                  :options="warningLevelOpt"
                  v-validate="'required'"
                  name="Warning Level"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Warning Level')"
                  >{{ errors.first("Warning Level") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Start At</label>
                <input
                  type="date"
                  v-model="item.start_at"
                  class="form-control"
                  placeholder="Start At"
                  v-validate="'required'"
                  name="Start At"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Start At')"
                  >{{ errors.first("Start At") }}</span
                >
              </div>
              <div class="form-group col">
                <label>Expired At</label>
                <b-form-input
                  type="datetime-local"
                  v-model="item.expired_at"
                  class="form-control"
                  placeholder="Expired At"
                  v-validate="'required'"
                  name="Expired At"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Expired At')"
                  >{{ errors.first("Expired At") }}</span
                >
              </div>
              <div class="form-group col-1" v-if="index >= 0">
                <button
                  type="button"
                  style="margin-left: auto"
                  class="btn btn-secondary mt-4"
                  @click="removeAreaUpdate(index)"
                >
                  <span class="fe fe-trash"></span>
                </button>
              </div>
            </div>
            <div class="row">
              <button
                type="button"
                class="btn btn-primary col-1"
                @click="addAreaUpdate"
              >
                <span class="fe fe-plus"></span> Add
              </button>
            </div>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false"
            >
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </button>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "restrictedAreaComponent",
  computed: {
    columns() {
      return this.$store.getters["restricted_area/columns"];
    },
    list() {
      return this.$store.getters["restricted_area/list"];
    },
    users() {
      return this.$store.getters["user/list"];
    },
    location() {
      return this.$store.getters["location/list"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      isAdd: true,
      isLoading: false,
      bodyAdd: {
        entity_type: "",
        entity_value: "",
        formAdd: [
          {
            location_id: "",
            warning_level: "",
            start_at: moment().format("YYYY-MM-DD"),
            expired_at: moment().format("YYYY-MM-DDThh:mm"),
          },
        ],
      },
      bodyUpdate: {
        id: "",
        entity_type: "",
        entity_value: "",
        formUpdate: [
          {
            location_id: "",
            warning_level: "",
            start_at: "",
            expired_at: "",
          },
        ],
      },
      targetTypeOpt: [
        { label: "PERSON", id: "PERSON" },
        { label: "ALL", id: "ALL" },
      ],
      warningLevelOpt: [
        { label: "1 - Prevent", id: "1" },
        { label: "2 - Protect", id: "2" },
        { label: "3 - Restrict", id: "3" },
        { label: "4 - Lockdown", id: "4" },
      ],
    };
  },
  mounted() {
    this.getList();
    this.getUser();
    this.getLocation();
  },
  methods: {
    getList() {
      this.$store.dispatch("restricted_area/GET_LIST");
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("YYYY/MM/DD HH:mm:ss");
      }
      return date;
    },
    format(value, event) {
      return moment(value).format("YYYY-MM-DDTHH:mm:ss");
    },
    addArea() {
      const blank_area = {
        location_id: "",
        warning_level: "",
        start_at: "",
        expired_at: "",
      };
      this.bodyAdd.formAdd.push(blank_area);
    },
    removeArea(index) {
      this.bodyAdd.formAdd.splice(index, 1);
    },
    addAreaUpdate() {
      const blank_area = {
        location_id: "",
        warning_level: "",
        start_at: "",
        expired_at: "",
      };
      this.bodyUpdate.formUpdate.push(blank_area);
    },
    removeAreaUpdate(index) {
      this.bodyUpdate.formUpdate.splice(index, 1);
    },
    updateData(props) {
      // return console.log(props.details);
      this.$bvModal.show("modal-1");
      this.isAdd = false;
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.entity_type = props.entity_type;
      this.bodyUpdate.entity_value = props.entity_value;

      let formUpdate = [];
      let details = props.details;
      for (let i = 0; i < details.length; i++) {
        const el = details[i];
        formUpdate.push({
          ...el,
          start_at: moment(el.start_at).format("YYYY-MM-DD"),
          expired_at: moment(el.expired_at).format("YYYY-MM-DDTHH:mm"),
        });
      }

      this.bodyUpdate.formUpdate = formUpdate;
    },
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        const data = {
          entity_type: this.bodyAdd.entity_type,
          entity_value: this.bodyAdd.entity_value,
          details: this.bodyAdd.formAdd,
        };
        // return console.log(data);
        try {
          this.isLoading = true;
          this.$store.dispatch("restricted_area/CREATE", data).then((resp) => {
            this.$swal({
              title: "Saved",
              text: "Your input has been saved",
              icon: "success",
              confirmButtonText: "OK",
            }).then((resp) => {
              this.isLoading = false;
              this.bodyAdd.entity_type,
                this.bodyAdd.entity_value,
                this.bodyAdd.formAdd,
                this.getList();
              this.$bvModal.hide("modal-1");
            });
          });
        } catch (resp) {
          this.$swal("Error", "Error while add data", "error");
        }
      });
    },
    saveUpdate() {
      const data = {
        id: this.bodyUpdate.id,
        entity_type: this.bodyUpdate.entity_type,
        entity_value: this.bodyUpdate.entity_value,
        details: this.bodyUpdate.formUpdate,
      };
      // return console.log(data);
      this.isLoading = true;
      this.$store
        .dispatch("restricted_area/UPDATE", data)
        .then((resp) => {
          this.$swal({
            title: "Saved",
            text: "Your input has been saved",
            icon: "success",
            confirmButtonText: "OK",
          }).then((resp) => {
            this.isLoading = false;
            this.getList();
            this.$bvModal.hide("modal-1");
          });
        })
        .catch((resp) => {
          this.$swal("Error", "Error while edit data", "error");
        });
    },
    remove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("restricted_area/DELETE", { id: id })
            .then(() => {
              this.$swal(
                "Success",
                "Area restriction has been deleted",
                "success"
              );
              this.getList();
            });
        }
      });
    },
    async getUser() {
      this.$store.dispatch("user/GET_LIST");
    },
    async getLocation() {
      this.$store.dispatch("location/GET_LIST");
    },
  },
};
</script>
